import { useCallback, useRef, useState } from 'react';

/**
 * The open state and anchor plumbing every Popover trigger needs: pass
 * `setAnchor` as the trigger's innerRef and `getAnchor` to the Popover.
 */
const usePopover = () => {
  const [open, setOpen] = useState(false);
  const anchor = useRef(null);

  const setAnchor = useCallback((node) => { anchor.current = node; }, []);
  const getAnchor = useCallback(() => anchor.current, []);
  const toggle = useCallback(() => setOpen(wasOpen => !wasOpen), []);
  const close = useCallback(() => setOpen(false), []);

  return {
    open, setAnchor, getAnchor, toggle, close
  };
};

export default usePopover;
